// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3RnbO","modalFooterButton":"ModalNotes_modalFooterButton__2QwDW"};